export const default_image_src = "/static/backgrounds/default-img.jpg"
export const default_logo_src = "/static/icons/ulsemo-icon.svg"
export const default_image_attachment = "data:image/jpeg;base64,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"

export const collection = "collection"
export const product = "product"
export const thumb_image_src_name = "thumb_image"

// Languages
const languages_map = {
  en: "en",
  de: "de",
  es: "es",
  cz: "cz",
  sk: "sk",
  sr: "sr",
  hr: "hr",
  pl: "pl",
  pt: "pt",
  ch: "ch",
  ind: "ind",
  jp: "jp",
  ru: "ru",
  vn: "vn",
}
export const languages = Object.values(languages_map)
export const translated_languages = [languages_map.en, languages_map.cz]
export const default_language = languages[0]
export const orders_API_date_format = "YYYY-MM-DDTHH:mm:ssZ"
export const date_time_format = "HH:mm DD.MM.YYYY"
export const date_time_format_dateformat = "HH:MM dd.mm.yyyy"
export const written_date_time_format = "HH:mm MMMM Do YYYY"
export const classic_date_format = "DD.MM.YYYY"
export const dashed_date_format = "YYYY-MM-DD"

// Order constants

export const order_action_types = {
  cancel: "cancel",
  close: "close",
  open: "open",
  fulfill: "fulfill",
  ship: "ship",
  edit: "edit",
  paid: "paid",
  zasilkovna: "zasilkovna"
}
export const order_fulfillment_statuses = {
  shipped: "shipped",
  unshipped: "unshipped",
  restocked: "restocked",
  zasilkovna: "zasilkovna"
}
export const order_financial_statuses = {
  authorized: "authorized",
  pending: "pending",
  paid: "paid",
  refunded: "refunded",
  voided: "voided"
}

// Currencies
export const currency_map = { // Also in functions/constans/other.js
  AUD: "AUD",
  BRL: "BRL",
  CAD: "CAD",
  CNY: "CNY",
  CZK: "CZK",
  DKK: "DKK",
  EUR: "EUR",
  HKD: "HKD",
  HUF: "HUF",
  INR: "INR",
  ILS: "ILS",
  JPY: "JPY",
  MYR: "MYR",
  MXN: "MXN",
  TWD: "TWD",
  NZD: "NZD",
  NOK: "NOK",
  PHP: "PHP",
  PLN: "PLN",
  GBP: "GBP",
  RUB: "RUB",
  SGD: "SGD",
  SEK: "SEK",
  CHF: "CHF",
  THB: "THB",
  USD: "USD",
}
export const currency_signs = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  INR: "₹",
  CZK: "Kč",
  AUD: "A$",
  BRL: "R$",
  CAD: "C$",
  CNY: "¥",
  DKK: "Kr",
  HKD: "HK$",
  HUF: "Ft",
  ILS: "₪",
  MYR: "RM",
  MXN: "Mex$",
  TWD: "NT$",
  NZD: "NZ$",
  NOK: "NOK",
  PHP: "₱",
  PLN: "zł",
  RUB: "₽",
  SGD: "S$",
  SEK: "SEK",
  CHF: "Fr.",
  THB: "฿",
}
export const allowed_currencies = Object.values(currency_map)
export const allowed_currency_signs = Object.values(currency_signs)
export const lang_to_currency_mapper = {
  [languages_map.ch]: currency_map.CNY,
  [languages_map.cz]: currency_map.CZK,
  [languages_map.de]: currency_map.EUR,
  [languages_map.jp]: currency_map.JPY,
  [languages_map.pt]: currency_map.EUR,
  [languages_map.es]: currency_map.EUR,
  [languages_map.ru]: currency_map.RUB,
  [languages_map.ind]: currency_map.ILS,
  [languages_map.en]: currency_map.USD,
  [languages_map.vn]: currency_map.CZK,
  [languages_map.hr]: currency_map.EUR
}

export const message_durations = {
  long: 10000,
  medium: 6000,
  short: 3000
}

export const content_pages = {
  LIKED: "liked"
}

export const user_cookie = "ulsemo_user_login"

export const current_store_key = "current_store"

export const SHARED_STORE = "Shared"

export const FIREBASE_JS_VERSION = "8.2.2"

export const social_logins = ["google", "facebook"]

export const payment_methods = {
  paypal: "paypal",
  bank_transfer: "bank_transfer",
  on_pickup: "on_pickup"
}

export const other_shipping_methods = {
  zasilkovna: "zasilkovna"
}
